import { render, staticRenderFns } from "./NewNegotiationWeight.vue?vue&type=template&id=482e1cfa"
import script from "./NewNegotiationWeight.vue?vue&type=script&lang=js"
export * from "./NewNegotiationWeight.vue?vue&type=script&lang=js"
import style0 from "./NewNegotiationWeight.vue?vue&type=style&index=0&id=482e1cfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports